import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "carousel-inner" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "image-carousel-caption text-center"
}
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = ["data-bs-target"]
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    ref: "carouselEl",
    class: "carousel slide image-carousel"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["carousel-item", { active: i === 0 }])
        }, [
          _createElementVNode("img", {
            src: img.src,
            class: "carousel-img",
            alt: img.alt || img.caption
          }, null, 8, _hoisted_3),
          (img.caption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(img.caption), 1))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "carousel-control-prev",
      type: "button",
      "data-bs-target": '#' + _ctx.id,
      "data-bs-slide": "prev"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", {
        class: "carousel-control-prev-icon",
        "aria-hidden": "true"
      }, null, -1),
      _createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
    ]))], 8, _hoisted_5),
    _createElementVNode("button", {
      class: "carousel-control-next",
      type: "button",
      "data-bs-target": '#' + _ctx.id,
      "data-bs-slide": "next"
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("span", {
        class: "carousel-control-next-icon",
        "aria-hidden": "true"
      }, null, -1),
      _createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
    ]))], 8, _hoisted_6),
    _createElementVNode("button", {
      type: "button",
      class: "carousel-playpause",
      "aria-label": _ctx.playing ? 'Pause slideshow' : 'Play slideshow',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: _ctx.playing ? 'fa-solid fa-pause' : 'fa-solid fa-play'
      }, null, 8, ["icon"])
    ], 8, _hoisted_7)
  ], 8, _hoisted_1))
}